import { useEffect, useState } from 'react';
import { Alert, Button, Dialog, Select, Textarea } from '@dreamtree-org/twreact-ui';

/**
 * A titled dialog that collects a reason (Select) and a message, then calls
 * onSubmit({ topic, message }). Used for cancel / return / support requests.
 */
export default function RequestDialog({ isOpen, onClose, title, intro, topics, submitLabel, requireMessage = true, loading, error, onSubmit, destructive }) {
  const [topic, setTopic] = useState(topics[0].value);
  const [message, setMessage] = useState('');
  useEffect(() => {
    if (isOpen) {
      setTopic(topics[0].value);
      setMessage('');
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Close</Button>
          <Button variant={destructive ? 'destructive' : 'primary'} loading={loading} disabled={requireMessage && !message.trim()} onClick={() => onSubmit({ topic, message })}>
            {submitLabel}
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        {intro ? <p className="text-sm opacity-80">{intro}</p> : null}
        <Select label="Reason" options={topics} value={topic} onChange={setTopic} closeOnSelect />
        <Textarea label={requireMessage ? 'Details' : 'Details (optional)'} rows={4} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={1000} showCount />
        {error ? <Alert variant="error">{error}</Alert> : null}
      </div>
    </Dialog>
  );
}
